<div
  class="deviation text-truncate d-flex"
  [style.color]="
    activityEndTimeType === ActivityDeviationStatus.Deviated
      ? '#FA541C'
      : '#108ee9'
  "
>
  @if (activityEndTimeDifference !== 0) {
    <div>
      {{
        activityEndTimeDifference > 0
          ? '+' + activityEndTimeDifference
          : activityEndTimeDifference
      }}
    </div>
  }
</div>
